<template>
    
    <v-card>
      <div class="loader" v-if="loading"></div>
      <v-card-title>
        <span class="headline">Evaluación: {{item.nombre}}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
                <template v-if="predicted">
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    sort-by="calories"
                    class="elevation-1"
                    :hide-default-footer="true"
                  >
                </v-data-table></template>
                <template v-else> 
                    <template v-if="error"> Hubo un error en el cálculo</template>
                    <template v-else> </template>
                </template>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close-dialog4', false);">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

</template>

<script>

    import Vue from 'vue'

    export default {
    props: ["item", "dialog"],

    data: () => ({
        selected: { name: 'Acierto', key: 'success' },
        loading: false,
        predicted: false,
        error: false,
        headers: [
          { text: 'Modelo', value: 'model' },
          { text: 'Score', value: 'score' },
        ],
        items: [],
    }),

    created () {



    },

    mounted() {

      this.loading = true;
      Vue.axios.get('predict/' + this.item.id + '/')
      .then(result => {
          //console.log(result.data);
          this.loading = false;
          if (result.data.status > 0) {
              this.predicted = true;
              this.items = result.data.probs;
          }
          else {
              this.error = true;
          }
      })
      .catch(error => {
          throw new Error(`API ${error}`);
      });
      
    },

    computed: {


    },

    watch: {

    },

    methods: {


    },

    components: {

    },

}
</script>

<style scoped>
    .loader{  /* Loader Div Class */
      position: absolute;
      top:0px;
      right:0px;
      width:100%;
      height:100%;
      background-color:#eceaea;
      background-image: url('../assets/spinner.gif');
      background-size: 50px;
      background-repeat:no-repeat;
      background-position:center;
      z-index:10000000;
      opacity: 0.4;
      filter: alpha(opacity=40);
    }
  
  </style>